<template>
    <div class="app">
        <img class="app-img" src="../../assets/img/bg0.jpg">
        <div class="app-con">
            <h2>{{role==0?'资料填写':'商铺'}}</h2>
            <div class="form_wrap">
                <div class="form_wrap_t"><span>年龄</span></div>
                <!-- <div class="item" v-if="role==0">
                  <div class="input_wrap">
                      <picker mode="selector" :range="infoArr[7].arr" range-key="text" @change="storeFn">
                        <input disabled placeholder="请选择您的身份" v-model="infoArr[7].value">
                        <span class="icon">
                              <img src="../../assets/img/info_more.png">
                        </span>
                      </picker>
                  </div>
                </div> -->
                <div class="item" v-if="role==0">
                  <div class="input_wrap"  @touchstart='startFu' @touchmove='moveFu' @touchend='itemFu(infoArr[3])'>
                      <input placeholder="请选择您的身份"  v-model="infoArr[3].value">
                      <span class="icon">
                            <img src="../../assets/img/info_more.png">
                      </span>
                  </div>
                </div>
                <div class="form_wrap_t"><span>户籍</span></div>
                <div class="item" v-if="role==0">
                  <div class="input_wrap"  @touchstart='startFu' @touchmove='moveFu' @touchend='itemFu(infoArr[6])'>
                      <input placeholder="请选择所属区域/单位"  v-model="infoArr[6].value">
                      <span class="icon">
                            <img src="../../assets/img/info_more.png">
                      </span>
                  </div>
                </div>
                <div class="form_wrap_t"><span>镇区</span></div>
                <div class="item" v-if="role==0">
                  <div class="input_wrap" @touchstart='startFu' @touchmove='moveFu' @touchend='itemFu(infoArr[0])'>
                      <input type="input" placeholder="您居住东城哪个社区" v-model="infoArr[0].value" >
                      <span class="icon">
                            <img src="../../assets/img/info_more.png">
                      </span>
                  </div>
                </div>
                <div class="item" v-if="role==1">
                  <div class="input_wrap">
                    <div>
                      <input placeholder="请输入您所在的街巷" @focus="focusFn" @input="inputFn" v-model="townArr.name">
                    </div>
                      
                      <ul class="list" v-if="isList">
                        <li v-for="(item,index) in townList" :key="index" @click="townClick(item)">{{item.text}}</li>
                      </ul>
                  </div>
                </div>
                <div class="item" v-if="role==1">
                  <div class="input_wrap">
                      <input placeholder="请输入您的门牌号" v-model="address" >
                  </div>
                </div>
                
                <div class="item" v-if="role==1">
                  <div class="sex_wrap">
                    <div class="name">性别：</div>
                    <div class="cont">
                      <span :class="[infoArr[2].id==item.value?'active': '']" v-for="(item,index) in infoArr[2].arr" :key="index" @click="sexFn(item)">{{item.text}}</span>
                      <!-- <span :class="[infoArr[2].id==1?'active': '']" @click="sexFn(1)" > 男</span>
                      <span :class="[infoArr[2].id==2?'active': '']" @click="sexFn(2)"> 女</span> -->
                    </div>
                  </div>
                </div>
                <div class="form_wrap_t"><span>联系方式</span></div>
                <div class="item" v-if="role==0">
                  <div class="input_wrap">
                      <input placeholder="请输入您电话号码" v-model="tel" >
                  </div>
                </div>
                <div class="tisp" v-if="role==1">以下两项仅工作人员填写</div>
                <div class="item" v-if="role==1">
                  <div class="input_wrap">
                      <input placeholder="请输入您的部门" v-model="check_depart" >
                  </div>
                </div>
                <div class="item" v-if="role==1">
                  <div class="input_wrap">
                      <input placeholder="请输入您的姓名" v-model="wj_name " >
                  </div>
                </div>
            </div>
            
            <!-- <dl class="app-dl" 
                v-for="(item,idx) in infoArr" 
                :key="idx"
                @touchstart='startFu' @touchmove='moveFu' @touchend='itemFu(item,idx)'
             >
               <dt>{{item.name}}</dt>
               <dd :class="{show:item.value}">
                 {{item.value?item.value:'请选择'}}
                 <img src="../../assets/img/info0.png">
               </dd>
             </dl> -->
             <!-- 提交按钮 -->
              <div class="app-btn" @touchstart='startFu' @touchmove='moveFu' @touchend='btnFu'>
                确认填写
                  <!-- <img v-if="!isbtn" src="../../assets/img/info1.png"> -->
                  <!-- <img src="../../assets/img/info2.png"> -->
              </div>
        </div>
        
        <!-- 下拉框组件 -->
        <!-- <caiPicker ref="caiPicker"></caiPicker> -->
        <!-- 提示组件 -->
        <caiToast ref="caiToast"></caiToast>
        <!-- 选择组件 -->
        <infoSelect ref="infoSelect"></infoSelect>
    </div>
</template>
<script>
// import caiPicker from '#/picker';//下拉框组件
import caiToast from '#/toast';//提示组件
import infoSelect from '@/components/infoSelect';//信息提示选择组件
export default {
  data () {
    return {
        role:null,//0市民，1店铺
        start:0,
        isbtn:false,//是否可以提交了
        storeArr:{
          id:'',
          name:''
        },
        // store_role:[
        //   {
        //     id:1,
        //     name:'店员'
        //   },
        //   {
        //     id:2,
        //     name:'店主'
        //   }
        // ],
        townArr:{
          id:'',
          name:''
        },
        townList:[],
        search:'',
        address:'',//门牌地址
        wj_name :'',//姓名
        check_depart:'',//部门
        tel: '',
        infoArr:[//数据
            {name:'您居住东城哪个社区？',tips:'选择镇区',value:'',id:-1,arr:[]},
            {name:'您在这个社区居住时间有多长？',tips:'居住时间',value:'',id:-1,arr:[]},
            {name:'您的性别？',tips:'性别',value:'',id:-1,arr:[]},
            {name:'您的年龄是？',tips:'年龄',value:'',id:-1,arr:[]},
            {name:'您的籍贯是？',tips:'籍贯',value:'',id:-1,arr:[]},
            {name:'您的居住区域是？',tips:'居住区域',value:'',id:-1,arr:[]},
            {name:'您的单位是？',tips:'户籍',value:'',id:-1,arr:[]},
            {name:'您的身份是？',tips:'身份',value:'',id:-1,arr:[]}
        ],
        serviceArr:['block','live_time','sex','age','native_place','area','occupation','store_role'],
        isajax:false,
        isList: false
    }
  },
  components: {
    // caiPicker,
    caiToast,infoSelect
  },
  beforeMount(){
    // console.log(e,123);
      this.role = 0;
      this.$http.get(`${this.service}questionnaire/config`).then((data)=>{
          this.serviceArr.forEach((e,idx)=>{
              let arr = [];
              if(e=='block'){
                data[e].forEach((item,index)=>{
                  arr.push({
                    text:item.block,
                    value:item.id
                  })
                })
              }else{
                for(let [value,text] of Object.entries(data[e])){
                  arr.push({
                      text,
                      value
                  })
                }
              }
              this.infoArr[idx].arr = arr;
              // console.log(arr,3333)
          })
      })
      // console.log(123)
  },
  methods: {
     startFu(){this.start = 0;},
     moveFu(){this.start = 1;},
     focusFn(){
       if(this.infoArr[0].id==-1){
         this.$refs.caiToast.showFu({
            msg:'社区不能为空',
            time:1500
          })
         return
       }
       this.isList = true
      //  console.log('触发焦点')
       this.searchFn(this.infoArr[0].id,this.townArr.name)
     },
     blurFn(){
       console.log(7777)
       this.isList = false
     },
     townClick(item){
       console.log(item,888)
       this.isList = false
       this.townArr.id = item.value
       this.townArr.name = item.text
     },
     inputFn(){
       if(this.infoArr[0].id==-1){
         this.$refs.caiToast.showFu({
            msg:'社区不能为空',
            time:1500
          })
        this.townArr = {
          id:'',
          name:''
        }
         return
       }
       this.searchFn(this.infoArr[0].id,this.townArr.name)
     },
     sexFn(item){
       this.infoArr[2].id = item.value
     },
     storeFn(e){
       this.infoArr[7].id = this.infoArr[7].arr[e.mp.detail.value].value
       this.infoArr[7].value = this.infoArr[7].arr[e.mp.detail.value].text
      //  this.storeArr.id = this.store_role[e.mp.detail.value].id
      //  this.storeArr.name = this.store_role[e.mp.detail.value].name
     },
     searchFn(id,name){
       this.$http.get(`${this.service}questionnaire/auto-town`,{id,name})
       .then(res=>{
        //  console.log(res)
         let arr = [];
         for(let [value,text] of Object.entries(res)){
           arr.push({
             text,
             value
           })
         }
         this.townList = arr
       })
     },
     itemFu(item,idx){//下拉框选择
     console.log(item,999)
         if(this.start == 1){return;}
         this.$refs.infoSelect.showFu({
             arr:item.arr,
             id:item.id,
             title:item.tips,
             callback:(obj)=>{
               if(item.tips=='居住哪个社区'){
                 this.townArr = {
                   id:'',
                   name:''
                 }
               }
                item.value = obj.text;
                item.id = obj.value;
                let arr = this.infoArr.filter((e)=>{
                    return !e.value;
                })
                if(arr.length>0){
                    this.isbtn = false;
                }else{
                    this.isbtn = true;
                }
            }
         })
        //  this.$refs.caiPicker.showFu({
        //        arr:item.arr,
        //        id:item.id,
        //        title:item.tips,
        //        callback:(obj)=>{
        //           item.value = obj.text;
        //           item.id = obj.value;
        //           let arr = this.infoArr.filter((e)=>{
        //               return !e.value;
        //           })
        //           if(arr.length>0){
        //               this.isbtn = false;
        //           }else{
        //               this.isbtn = true;
        //           }
        //        }
        //  });
     },
     tispFn(info){
        this.$refs.caiToast.showFu({
          msg:info,
          time:1500
        })
     },
     btnFu(){//提交点击
         if(this.start == 1 || this.isajax){return;}
        //  if(!this.isbtn){
        //      let arr = this.infoArr.filter((e)=>{
        //          return !e.value;
        //      })
        //      let info = arr[0].tips+'不能为空!';
        //      this.$refs.caiToast.showFu({
        //          msg:info,
        //          time:1500
        //     })
        //     return;
        //  }
         //整理要提交的数据
       
        // let upDataArr = ['block_id','live_time','sex','age','native_place','live_area','occupation']
        // let upData = {};
        // upDataArr.forEach((e,idx)=>{
        //     upData[e] = this.infoArr[idx].id;
        // }) 
        // console.log(this.role,123)
        // console.log(this.infoArr,1233)
        let upData = {}
        // upData['role'] = this.role;
        if(this.role==0){
          if(this.infoArr[3].id==-1){
            this.tispFn('年龄段不能为空')
            return
          }
          if(this.infoArr[6].id==-1){
            this.tispFn('户籍不能为空')
            return
          }
          if(this.infoArr[0].id==-1){
            this.tispFn('镇区不能为空')
            return
          }
          upData['age'] = this.infoArr[3].id;
          upData['unit'] = this.infoArr[6].value;
          upData['block_id'] = this.infoArr[0].id;
          upData['block'] = this.infoArr[0].value;
          // upData['sex'] = this.infoArr[2].id;
          
        }else{
          if(this.infoArr[0].id==-1){
            this.tispFn('社区不能为空')
            return
          }
          if(this.townArr.name==''){
            this.tispFn('街巷不能为空')
            return
          }
          if(this.address==''){
            this.tispFn('门牌号不能为空')
            return
          }
          if(this.infoArr[7].id==-1){
            this.tispFn('身份不能为空')
            return
          }
          if(this.infoArr[3].id==-1){
            this.tispFn('年龄为空')
            return
          }
          if(this.infoArr[2].id==-1){
            this.tispFn('性别不能为空')
            return
          }
         
          // upData['block_id'] = this.infoArr[0].id;
          upData['unit'] = this.infoArr[6].id;
          // upData['sex'] = this.infoArr[2].id;
          upData['town_id'] = this.townArr.name;
          upData['address'] = this.address;
          upData['store_role'] = this.infoArr[7].id;
          upData['check_depart'] = this.check_depart;
          upData['wj_name'] = this.wj_name;
        }
        // if(this.infoArr[6].id==1){
        //   if(this.infoArr[0].id==-1){
        //     this.tispFn('镇区不能为空')
        //     return
        //   }
        //   upData['block_id'] = this.infoArr[0].id;
        //   upData['block'] = this.infoArr[0].value;
        // }

        if(this.tel==''){
          this.tispFn('手机号码不能为空')
          return
        }
        const phoneReg = /^(13|14|15|16|17|18|19)\d{9}$/g
        if(!phoneReg.test(this.tel)){
          this.tispFn('手机号码格式不符')
          return 
        }
        upData['mobile'] = this.tel;
        //  this.isajax = true;
        // console.log(upData,33)
        //  console.log(upData)
        //  return
        //发请求


        this.$http.post(`${this.service}questionnaire/user-msg?access-token=${this.$store.state.access_token}`,upData).then((data)=>{
             this.isajax = false;
             if(data.status == 1){
                 //data.info = '提交成功,正在跳转,请稍等';
                 let d = this.$store.state.status;
                 d.msg = 1;
                 this.$store.commit('setStatus',d);
                 setTimeout(()=>{
                   // this.setStorageSync('isinfo',1);//储存下本地
                    this.$router.replace('answer');
                },1500)
             }
             this.$refs.caiToast.showFu({
                msg:'保存成功',
                time:1500
             })
        })
     },
  },
  onLoad() {
    Object.assign(this.$data, this.$options.data())//重置data初始化
  },
  onShareAppMessage(){//自定义转发
      return {
        title: '平安有我 民意收集',
        path: '/pages/index/main'
      }
  }
}
</script>

<style scoped lang="less">
@import '../../assets/css/less.less';
.app{position: relative; z-index: 0; width: 100%; height: 100%;
box-sizing: border-box; padding: 53/@r 50/@r 0;
}
.app-img{position: fixed; left: 0; top: 0; z-index: -1; width: 100%; height: 100%;}
.app-con{ background: rgba(255, 255, 255, 1); width: 100%;
box-sizing: border-box; padding: 0 20/@r 45/@r; border-radius: 10/@r;border: 6/@r solid #5edacd;
}
.app-con h2{ width: 100%; text-align: center; padding-top: 36/@r; font-size: 38/@r; font-weight: bold;
  color: #31966d;letter-spacing: .1rem;text-indent: .1rem;
}

.form_wrap{
  padding: 0 .44rem;
  .tisp{
    font-size: .24rem;
    color: #00a0e9;
    margin-top: .50rem;
  }
  .form_wrap_t{
    width: 100%;
    position: relative;
    padding: 40/@r 0 17/@r;
    box-sizing: border-box;
    margin: 0;
    // height: 102/@r;
    span{
      font-size: 28/@r;
      // float: left;
      padding-left: 20/@r;
      border-left: 4/@r solid #31966d;
      display: block;
      line-height: 30/@r;
      color: #31966d;
      margin: 0;
    }
  }
  .item{
    // margin-top: .50rem;
    .input_wrap{
      position: relative;
      height: 1rem;
      background: #f6f6f6;
      border-radius: .15rem;
      border: 1px solid #5edacd;
      input{
        height: 1rem;
        font-size: .26rem;
        color: #333333;
        padding: 0 .30rem;
        opacity: 1;
        float: left;
        background-color: transparent;
      }
      .icon{
        position: absolute;
        right: .40rem;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: .1rem;
          height: .2rem; 
        }
      }
      .list{
        background: #87c0ff;
        position: absolute;
        left: 0;
        top: 100%;
        right: 0;
        z-index: 999;
        max-height: 4rem;
        overflow-y: auto;
        padding: 0 .18rem;
        li{
          font-size: .26rem;
          color: #ffffff;
          line-height: 1rem;
          overflow: hidden;
          text-align: center;
          border-bottom: 1px dashed #ffffff;
        }
      }
    }
    .sex_wrap{
      .name{
        display: inline-block;
        font-size: .26rem;
        color: #f74a3a;
        line-height: .50rem;
      }
      .cont{
        display: inline-block;
        line-height: .50rem;
        span{
          font-size: .26rem;
          color: #f74a3a;
          position: relative;
          padding-left: .52rem;
          margin-left: .8rem;
          &::before{
            content: "";
            display: block;
            width: .22rem;
            height: .22rem;
            border: 1px solid #f74a3a;
            border-radius: 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .active{
          &::before{
            background: #f74a3a;
          }
        }
      }
    }
  }
  // .item:nth-child(1){
  //   margin-top: 0;
  // }
}
//内容部分
.app-dl{ width: 100%; .box;
justify-content: space-between;
-webkit-justify-content: space-between;
border-bottom: 1/@r solid #ededed;
}
.app-dl dt,.app-dl dd{ height: 90/@r; .box; font-size: 30/@r; color: #333;}
.app-dl dd{position: relative; color: #999999; font-size: 26/@r;
 padding-right: 25/@r;
}
.app-dl .show{ color: #2366af;}
.app-dl dd img{position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 14/@r; height: 24/@r;}
//提交按钮部分
.app-btn{
  // position: absolute; 
  // left: 50%; 
  // bottom:7.2%; 
  // transform: translateX(-50%); .box;
  margin: .7rem auto 0;
  height: .94rem;
  border-radius: .1rem;
  background-color: #31966d;
  color: #fff;
  font-size: .28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - .88rem);
  }
// .app-btn img{ width: 151/@r; height: 62/@r;}
</style>



// WEBPACK FOOTER //
// src/pages/info/index.vue